import { render, staticRenderFns } from "./Actualize.vue?vue&type=template&id=6009e64c"
import script from "./Actualize.vue?vue&type=script&lang=js"
export * from "./Actualize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports